// extracted by mini-css-extract-plugin
export var attachment = "_op-a";
export var emailContainer = "_op-4";
export var emailContentPaddedContainer = "_op-b";
export var emailHeader = "_op-6";
export var emailIframe = "_op-3";
export var emailInfoIcon = "_op-9";
export var emailShortenedSummary = "_op-e";
export var infoDropdown = "_op-0";
export var infoRowBoundedContent = "_op-d";
export var internal = "_op-5";
export var merchant = "_op-8";
export var messageInputContainer = "_op-h";
export var normal = "_op-7";
export var replyCard = "_op-f";
export var subtleButton = "_op-1";
export var subtleButtonIconContainer = "_op-2";
export var toggleViewRepliesButton = "_op-c";
export var wrappingText = "_op-g";